import { RefObject, useEffect } from 'react';
import type { Options } from './_common';
import { handleEvents } from './_handle_event';

export function useArrowNavigation<T extends HTMLElement>(containerRef: RefObject<T>, options: Options): void {
	useEffect(() => {
		function eventHandler(event: KeyboardEvent): void {
			handleEvents(event, containerRef, options);
		}

		document.addEventListener('keydown', eventHandler);

		return () => {
			document.removeEventListener('keydown', eventHandler);
		};
	}, [containerRef, options]);
}
